/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';

export class Currency extends Model {
  id: number;
  active: boolean;
  code: string;
  exchange_rate: number;
  format: string;
  name: string;
  symbol: string;
  order_index: string;
}
